const data = [
    { id: 1, name: "Video" },
    { id: 2, name: "Tutorial PDF" },
    { id: 3, name: "Imagem" },
];
  
export default [...data];
  